import { useVisaAuth } from 'app/shared/utils/visa';
import { EventForCompactEventCard } from 'app/shared/typings';
import { GetEventsVariables } from 'app/shared/graphql/events/queryHooks';
import { dateToYMD } from 'app/fan/utils/dates';
import { GetEventsForFan } from 'app/fan/graphql/events/queryHooks';
import { useEventPageContext } from 'app/fan/context/EventPage';

interface MoreLocalEventsProps {
  withNeighborhood?: boolean;
}

export function useMoreLocalEvents({
  withNeighborhood = false,
}: MoreLocalEventsProps = {}): EventForCompactEventCard[] {
  const { event } = useEventPageContext();
  const { visaPreSaleEligible, canBypassVisaValidation } = useVisaAuth({
    skipLoadCardRedemptionsStatus: true,
  });

  const variables: GetEventsVariables = {
    city: event?.city.cachedSlug,
    date: dateToYMD(new Date(event?.localStartsAt || new Date())),
    excludeCancelled: true,
    excludeNonPresale: false,
    excludePresale: !visaPreSaleEligible && !canBypassVisaValidation,
    excludeSoldOut: true,
    globallyPromoted: true,
    includeNearbySecondaryCities: !withNeighborhood,
    page: 1,
    perPage: 4,
    published: true,
    upcoming: true,
  };

  if (withNeighborhood) {
    variables.neighborhood = event?.venue?.neighborhood?.cachedSlug;
  }

  const { data: moreLocalEventsResponse } = GetEventsForFan({
    notifyOnNetworkStatusChange: true,
    ...variables,
  });

  const events = moreLocalEventsResponse?.events?.events;
  const moreLocalEvents: EventForCompactEventCard[] = events
    ? // Filter out the current event so we don't show it in the more events section
      events
        .filter(
          (localEvent: EventForCompactEventCard) => localEvent.id !== event?.id
        )
        .slice(0, 3)
    : [];

  return moreLocalEvents;
}
